module.exports = __webpack_public_path__ + "static/img/reward-1.c8d1f633.png";